import React from 'react';
import { InputGroup, Form, Button } from 'react-bootstrap';
import { BsSearch, BsX } from 'react-icons/bs';

const Search = (props) => {
  const { onSearch, searchData } = props;

  // Função para limpar o campo de busca
  const handleClear = () => {
    // Cria um evento simulado com target.value vazio
    const event = { target: { value: '' } };
    onSearch(event);
  };

  return (
    <InputGroup
      className="m-0 position-relative"
      style={{
        borderRadius: '0.25rem',
        boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
        background: '#f8f9fa',
        maxWidth: '350px',
        minHeight: '28px',
        alignItems: 'center',
        border: '1px solid #dee2e6'
      }}
    >
      <Form.Control
        className="border-0"
        aria-label="Default"
        aria-describedby="inputGroup-sizing-default"
        placeholder="Filtro"
        value={searchData}
        onChange={onSearch}
        size="sm"
        style={{
          borderRadius: '0.25rem',
          background: 'transparent',
          boxShadow: 'none',
          paddingLeft: '12px',
          paddingRight: '32px',
          fontSize: '0.97rem',
          height: '28px',
          transition: 'box-shadow 0.2s',
        }}
        onFocus={e => e.target.style.boxShadow = '0 0 0 2px #b6d4fe'}
        onBlur={e => e.target.style.boxShadow = 'none'}
      />
      {searchData && (
        <Button
          variant="link"
          className="position-absolute"
          style={{
            right: '35px',
            zIndex: 5,
            border: 'none',
            background: 'transparent',
            padding: '0 4px',
            height: '100%',
            display: 'flex',
            alignItems: 'center'
          }}
          onClick={handleClear}
          title="Limpar busca"
        >
          <BsX size={18} color="#888" />
        </Button>
      )}
      <InputGroup.Text
        style={{
          background: 'transparent',
          border: 'none',
          paddingRight: '10px',
          paddingLeft: '6px',
          color: '#888',
          fontSize: '1.1rem'
        }}
      >
        <BsSearch />
      </InputGroup.Text>
    </InputGroup>
  );
};

export default Search;
